<template>
  <div class="response-list" v-if="responses">
    <div :ref="responseListRef" class="response-list__wrapper" v-if="responsesPaginated.length > 0">
      <div style="display: flex; flex-direction: row">
        <input
          type="checkbox"
          class="datasets__table-checkbox"
          name="textrow-selectall-checkbox"
          id="'textrow-selectall-checkbox"
          style="
            width: 1.3rem;
            height: 1.3rem;
            cursor: pointer;
            display: flex;
            margin: 1rem 1rem -1rem 1rem;
          "
          v-model="allVisibleSelected"
          @click="selectAllVisible()"
        />
        <div style="display: flex; margin: 1rem 0 0 0">
          <VisibleText>Select all visible</VisibleText>
        </div>
        <input
          type="checkbox"
          class="datasets__table-checkbox"
          name="textrow-selectall-checkbox"
          id="'textrow-selectall-checkbox"
          style="
            width: 1.3rem;
            height: 1.3rem;
            cursor: pointer;
            display: flex;
            margin: 1rem 1rem -1rem 1rem;
          "
          v-model="allSelected"
          @click="selectAll()"
        />
        <div style="display: flex; margin: 1rem 0 0 0">
          <VisibleText>Select all</VisibleText>
        </div>
      </div>
      <div
        style="display: flex; position: relative; flex-direction: row"
        v-for="(item, index) in responsesPaginated"
        :key="item.idx"
      >
        <input
          type="checkbox"
          class="datasets__table-checkbox"
          name="textrow-checkbox"
          :id="'textrow-checkbox-' + item.idx"
          :checked="selectedBoxes.includes(index)"
          style="width: 1.3rem; height: 1.3rem; cursor: pointer; display: flex; margin: 3rem 1rem"
          @click="addToCheckedTextRow(item, index)"
        />
        <div
          style="
            z-index: 10;
            background-color: white;
            border-top: 0;
            border-radius: 0 0 4px 4px;
            color: var(--base-colour);
            position: absolute;
            margin-top: 2rem;
            box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
            border: 1px solid var(--outline-colour);
            border-radius: 8px;
            margin-left: 2rem;
            width: 13rem;
          "
          v-if="checkedTextRow.length && checkedTextRow[checkedTextRow.length - 1].id == item.id"
        >
          <div style="margin-left: 0.5rem">
            <VisibleText> {{ checkedTextRow.length }} text rows selected</VisibleText>
          </div>

          <div class="theme-options-btn" @click="onClickPin(!isPinned(item))">
            <SvgIconDecorative :icon="isPinned(item) ? 'remove' : 'pin'" />
            <span v-if="isPinned(item)"><VisibleText>Unpin</VisibleText></span>
            <span v-else><VisibleText>Pin</VisibleText></span>
          </div>
          <div
            @click="onClickHide(!hiddenComments.includes(item.id))"
            class="theme-options-btn"
            :style="propReadOnly ? 'cursor: not-allowed' : ''"
          >
            <SvgIconDecorative icon="eye" />
            <span v-if="hiddenComments.includes(item.id)"><VisibleText>Unhide</VisibleText></span>
            <span v-else><VisibleText>Hide</VisibleText></span>
          </div>

          <div
            @click="onClickBan"
            class="theme-options-btn"
            :style="propReadOnly ? 'cursor: not-allowed' : ''"
          >
            <SvgIconDecorative icon="ban" />
            <VisibleText>Ban</VisibleText>
          </div>
        </div>
        <ResponseListItem
          class="response-list__item"
          style="width: 100%; max-width: 82vw; margin: 2rem 1rem 2rem 0"
          :style="index == 0 ? 'margin-top: 0.5rem' : ''"
          tabindex="0"
          :item="item"
          :index="index"
          :propReadOnly="propReadOnly"
          :datasetIDQuestions="datasetIDQuestions"
          :client-question-id="clientQuestionId"
          :is-hidden="hiddenComments.includes(item.id)"
          :highlight-items="getHighlightItemsMethod(item)"
          :textAnalysisObject="textAnalysisObject"
          :hasPreProcessedText="hasPreProcessedText"
          :sortedThemes="sortedThemes"
          @showSentimentDetails="$emit('showSentimentDetails', $event)"
          @keyword="onKeyword"
          @note="onNote"
          @search="onSearch"
          @remove-keyword="$emit('remove-keyword', $event)"
          @ban-response="$emit('ban-response', $event)"
          @adjust-sentiment="$emit('adjust-sentiment', $event)"
          @toggle-response-hide="$emit('toggle-response-hide', item.id)"
          @runSortAndSelect="$emit('runSortAndSelect')"
          @updateTextObject="$emit('updateTextObject', $event)"
          @find-similar="findSimilar($event)"
          @updateTheme="$emit('updateTheme', $event)"
          @refreshTheme="refreshTheme($event)"
          @removeTheme="removeTheme($event)"
        />
      </div>

      <div class="response-list__load-more">
        <button
          class="response-list__load-more-btn"
          v-if="isLoadMoreBtnVisible"
          @click.stop="handleLoadMoreEvent"
        >
          <VisibleText>Load more responses</VisibleText>
        </button>
        <VisibleText v-else>End of response list</VisibleText>
      </div>
    </div>
    <div style="display: flex; margin: auto; flex-direction: column">
      <div style="display: flex; margin: auto; flex-direction: row; margin-bottom: 1rem">
        <button
          class="response-list__load-more-btn"
          style="width: 100%"
          v-if="responsesPaginated.length != responses.length"
          @click.stop="handleLoadAllResponses"
        >
          <VisibleText>Open all responses</VisibleText>
        </button>
        <div style="display: flex; margin: auto; flex-direction: row">
          <button
            class="response-list__load-more-btn"
            style="width: 100%"
            v-if="responsesPaginated.length != responses.length"
            @click.stop="handleLoadToResponse"
          >
            <VisibleText style="display: flex; margin-right: -2rem; width: 8rem"
              >Open to entry:</VisibleText
            >
          </button>
          <input
            v-if="responsesPaginated.length != responses.length"
            id="filter_themes"
            type="text"
            name="Filter themes"
            placeholder="enter entry/row number"
            style="display: flex; margin: auto 0"
            v-model="loadToThis"
          />
        </div>
      </div>

      <div v-if="isLoadingAllResponses" style="display: flex; width: 100%">
        <div
          class="also-found__loading-spinner spinner"
          style="margin: 1rem auto; width: 1rem; height: 1rem"
        ></div>
      </div>
    </div>

    <div class="response-list__empty-wrapper" v-show="responses.length === 0">
      <p class="response-list__empty-message" v-if="!showResponseListLoadingSpinner">
        <VisibleText>
          No responses found. Please try changing the filters, use a new search keyword or select a
          different text question.
        </VisibleText>
      </p>
    </div>

    <!-- Modals -->
    <!-- This is the same as ThemesAdd -->
    <SelectedTextModal
      ref="MainSentimentThemesAddRef"
      :type="selectedTextModalType"
      :propReadOnly="propReadOnly"
      :textAnalysisObject="textAnalysisObject"
      :selection="selection"
      :show="isSelectedTextModalVisible"
      :selectedTextModalResponseId="selectedTextModalResponseId"
      :hasPreProcessedText="hasPreProcessedText"
      :includeSmartCoverage="includeSmartCoverage"
      :responses="responses"
      :sortedThemes="sortedThemes"
      @updateExistingThemeTitle="updateExistingThemeTitle"
      @removeTheme="removeTheme($event)"
      @updateTheme="$emit('updateTheme', $event)"
      @refreshTheme="$emit('refreshTheme', $event)"
      @closeModal="closeModal"
      @updateTextObject="$emit('updateTextObject', $event)"
    />
    <CreateNoteModal
      ref="MainSentimentCreateNoteRef"
      v-if="textAnalysisObject"
      :allResponses="responses"
      :textAnalysisObject="textAnalysisObject"
      :selection="selection"
      :propReadOnly="propReadOnly"
      :show="isCreateNoteModalVisible"
      :sortedThemes="sortedThemes"
      @updateTheme="$emit('updateTheme', $event)"
      @refreshTheme="$emit('refreshTheme', $event)"
      @closeModal="closeModal"
      @updateTextObject="$emit('updateTextObject', $event)"
    />

    <SimilarSentencesPopUp
      ref="NotesSimilarSentencesPopup"
      :source="'ResponseList'"
      :textAnalysisObject="textAnalysisObject"
      :sortedThemes="sortedThemes"
      @selectThisResponse="$emit('selectThisResponse', $event)"
      @updateTheme="$emit('updateTheme', $event)"
    />
  </div>
</template>

<script>
// Components
import ResponseListItem from './ResponseListItem.vue';
import SimilarSentencesPopUp from '../../Components/SimilarSentencesPopUp.vue';
import SvgIconDecorative from '@/components/UI/Svg/SvgIcon';

// Mixins
import SelectTextMixin from '../Mixins/selectTextMixin.js';
import ResponseListPaginationMixin from '../Mixins/responseListPaginationMixin.js';
import textAnalysisMixin from '../../Mixins/textAnalysisMixin.js';
import ConfirmMixin from '/src/utils/mixins/confirmMixin.js';

export default {
  name: 'ResponseList',
  mixins: [SelectTextMixin, ResponseListPaginationMixin, textAnalysisMixin, ConfirmMixin],
  components: {
    ResponseListItem,
    SimilarSentencesPopUp,
    SvgIconDecorative,
  },
  props: {
    datasetIDQuestions: {
      default: () => [],
      type: Array,
    },
    isSentiment: {
      type: Boolean,
      default: () => false,
    },
    responses: {
      type: Array,
      default: () => [],
    },
    clientQuestionId: {
      type: String,
      default: () => {},
    },
    hiddenComments: {
      type: Array,
      default: () => [],
    },
    getHighlightItemsMethod: {
      type: Function,
      default: () => () => {},
    },
    textAnalysisObject: {
      type: Object,
      required: false,
      default: () => {},
    },
    hasPreProcessedText: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    includeSmartCoverage: {
      type: String,
      default: () => 'exclude',
    },
    sortedResponsesLength: {
      type: Number,
      required: false,
      default: () => 0,
    },
    sortedThemes: {
      type: Array,
      default: () => [],
    },
    propReadOnly: {
      default: () => false,
      type: Boolean,
    },
  },
  data() {
    return {
      checkedTextRow: [],
      selectedBoxes: [],
      allSelected: false,
      allVisibleSelected: false,
      isLoadingAllResponses: false,
      loadToThis: 20,
    };
  },
  computed: {
    /* paginated responses - depends on responseListPaginationMixin.js */
    responsesPaginated: function () {
      if (!this.responses) {
        return [];
      }
      let newResponses = this.deepCloneObj(this.responses);
      newResponses = newResponses.filter(
        (response) => !this.textAnalysisObject.bannedComments.includes(response.id),
      );
      if (this.numResponsesToDisplay < newResponses.length) {
        return newResponses.slice(0, this.numResponsesToDisplay);
      }

      return newResponses;
    },
    sentimentSortOrder: function () {
      return this.textAnalysisObject.sentimentSortOrder;
    },
    showResponseListLoadingSpinner: function () {
      return this.$store.getters['analysisText/getShowResponseListLoadingSpinner'];
    },
    isLoadMoreBtnVisible: function () {
      if (!this.responses) {
        return false;
      }
      return this.responsesPaginated.length < this.responses.length;
    },
  },
  mounted() {
    this.isComponentMounted = true;
  },
  methods: {
    deepCloneObj(obj) {
      // deep clones an object using JSON stringify (data loss might occur)
      if (Array.isArray(obj)) {
        return obj.map((item) => JSON.parse(JSON.stringify(item)));
      } else if (typeof obj == 'object') {
        return JSON.parse(JSON.stringify(obj));
      }
    },
    refreshThemesFromParent() {
      if (this.$refs.MainSentimentThemesAddRef) {
        this.$refs.MainSentimentThemesAddRef.refreshThemesFromParent();
      }
      if (this.$refs.MainSentimentCreateNoteRef) {
        this.$refs.MainSentimentCreateNoteRef.refreshThemesFromParent();
      }
    },
    handleLoadMoreEvent: function () {
      if (!this.isLoadMoreBtnVisible) return;
      this.loadMore();
    },
    handleLoadAllResponses: function () {
      this.isLoadingAllResponses = true;
      setTimeout(() => (this.loadMore(this.responses.length), 2000));
    },
    handleLoadToResponse: function () {
      if (this.loadToThis >= 20) {
        if (this.loadToThis > this.responses.length) {
          this.loadToThis = this.responses.length;
        }
        this.isLoadingAllResponses = true;
        setTimeout(() => (this.loadMore(this.loadToThis), 2000));
      }
    },
    findSimilar(action) {
      if (this.$refs['NotesSimilarSentencesPopup']) {
        this.$refs['NotesSimilarSentencesPopup'].forceOpen(action);
      }
    },
    selectAllVisible() {
      if (!this.allVisibleSelected) {
        let allResponses = this.deepCloneObj(this.responsesPaginated);
        let selectedBoxes = this.deepCloneObj(this.selectedBoxes);
        let checkedTextRow = this.deepCloneObj(this.checkedTextRow);
        selectedBoxes = [];
        for (let i = allResponses.length - 1; i >= 0; i--) {
          selectedBoxes.push(i);
          checkedTextRow.push(allResponses[i]);
        }
        this.selectedBoxes = selectedBoxes;
        this.checkedTextRow = checkedTextRow;
      } else {
        this.selectedBoxes = [];
        this.checkedTextRow = [];
      }
    },
    selectAll() {
      if (!this.allSelected) {
        let allResponses = this.deepCloneObj(this.responses);
        let selectedBoxes = this.deepCloneObj(this.selectedBoxes);
        let checkedTextRow = this.deepCloneObj(this.checkedTextRow);
        selectedBoxes = [];
        for (let i = allResponses.length - 1; i >= 0; i--) {
          if (!this.textAnalysisObject.bannedComments.includes(allResponses)) {
            selectedBoxes.push(i);
            checkedTextRow.push(allResponses[i]);
          }
        }
        this.selectedBoxes = selectedBoxes;
        this.checkedTextRow = checkedTextRow;
      } else {
        this.selectedBoxes = [];
        this.checkedTextRow = [];
      }
    },
    addToCheckedTextRow(checked_text_row, index) {
      let checkedTextRow = this.deepCloneObj(this.checkedTextRow);
      let checkedTextRowFilter = [];
      let selectedBoxes = this.deepCloneObj(this.selectedBoxes);

      checkedTextRowFilter = checkedTextRow.filter((text) => text.id == checked_text_row.id);
      if (checkedTextRowFilter.length) {
        this.checkedTextRow = checkedTextRow.filter((text) => text.id != checked_text_row.id);
        this.selectedBoxes = selectedBoxes.filter((box) => box != index);
      } else {
        this.checkedTextRow.push(checked_text_row);
        this.selectedBoxes.push(index);
      }
    },
    onClickPin(toPin) {
      let rowsToPin = this.deepCloneObj(this.checkedTextRow);
      // if toPin, add all
      if (toPin) {
        this.selectionChanged(rowsToPin);
      }
      // if unPin, remove all that are in that list
      else {
        if (
          this.textAnalysisObject.selectedResponseIds &&
          this.textAnalysisObject.selectedResponseIds.length
        ) {
          // Get objects that are in the current list, unless they match the following ids
          let rowsToPin = this.deepCloneObj(this.checkedTextRow);
          let idsToUnpin = [];
          for (let i = 0; i < rowsToPin.length; i++) {
            if (
              this.textAnalysisObject.selectedResponseIds &&
              this.textAnalysisObject.selectedResponseIds.length
            ) {
              let idToUnpin = rowsToPin[i].id;
              if (rowsToPin[i].id.$oid) {
                idToUnpin = rowsToPin[i].id.$oid;
              }
              idsToUnpin.push(idToUnpin);
            }
          }
          let newSelection = [];
          let allRows = [];
          if (this.selectAllVisible) {
            allRows = this.deepCloneObj(this.responsesPaginated);
          } else {
            allRows = this.deepCloneObj(this.responses);
          }
          for (let i = 0; i < allRows.length; i++) {
            if (
              this.textAnalysisObject.selectedResponseIds &&
              this.textAnalysisObject.selectedResponseIds.length
            ) {
              let selectedId = allRows[i].id;
              if (allRows[i].id.$oid) {
                selectedId = allRows[i].id.$oid;
              }
              if (this.textAnalysisObject.selectedResponseIds.includes(selectedId)) {
                if (!idsToUnpin.includes(selectedId)) {
                  newSelection.push(allRows[i]);
                }
              }
            }
          }
          this.selectionChanged(newSelection);
        }
      }
    },
    isPinned(item) {
      if (
        this.textAnalysisObject.selectedResponseIds &&
        this.textAnalysisObject.selectedResponseIds.length
      ) {
        for (let i = 0; i < this.textAnalysisObject.selectedResponseIds.length; i++) {
          if (this.textAnalysisObject.selectedResponseIds[i] == item.id) {
            return true;
          }
        }
      }
      return false;
    },
    onClickBan() {
      if (this.propReadOnly) return;
      this.setConfirmText({
        btn: 'yes',
        title: 'Confirm ban response?',
        message: 'Are you sure you want to ban the selected response item?',
      });
      this.setConfirmType('delete');
      this.setConfirmSourceComponent('ResponseList');
      this.setConfirmStatus(false);
      this.setConfirmIsVisible(true);
    },
    // Takes 'checked text' and either hides or unhides. It merges with existing comments
    onClickHide(toHide) {
      if (toHide) {
        let rowsToHide = this.deepCloneObj(this.checkedTextRow);
        let hiddenComments = this.deepCloneObj(this.textAnalysisObject.hiddenComments);
        // Remove duplicates from existing hidden comment
        rowsToHide = rowsToHide.filter((row) => !hiddenComments.includes(row.id));
        rowsToHide = rowsToHide.map((row) => row.id);
        hiddenComments = hiddenComments.concat(rowsToHide);
        this.toggleResponseItemsHide(hiddenComments);
      } else {
        let rowsToUnhide = this.deepCloneObj(this.checkedTextRow);
        rowsToUnhide = rowsToUnhide.map((row) => row.id);
        let hiddenComments = this.deepCloneObj(this.textAnalysisObject.hiddenComments);
        // Copy hidden comment and remove any from the sent list.
        hiddenComments = hiddenComments.filter((comment) => !rowsToUnhide.includes(comment));
        this.toggleResponseItemsHide(hiddenComments);
      }
      this.selectedBoxes = [];
      this.checkedTextRow = [];
    },
    refreshTheme(theme_id) {
      this.$emit('refreshTheme', theme_id);
    },
    async removeTheme(theme) {
      await this.$emit('removeTheme', theme);
    },
  },
  watch: {
    responses: {
      immediate: true,
      handler: function (val) {
        if (!val || !Array.isArray(val)) return;
        this.resetResponseListPagination();
      },
    },
    sentimentSortOrder: function () {
      this.$refs[this.responseListRef].scrollTop = 0;
    },
    confirmStatus: async function (val) {
      // only delete if status is true
      if (val && this.confirmSourceComponent === 'ResponseList' && this.confirmType === 'delete') {
        let selection = [];
        let rowsToBan = this.deepCloneObj(this.checkedTextRow);
        for (let i = 0; i < rowsToBan.length; i++) {
          selection.push(rowsToBan[i].id);
        }
        this.checkedTextRow = [];
        this.selectedBoxes = [];
        this.banResponseItems(selection);
        this.$router.go(0); // to force a reloading of all values - TODO find a better way to manage this
      }
    },
  },
};
</script>
